// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/common.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/common.proto.
 */
export const file_api_proto_v1_common: GenFile = /*@__PURE__*/
  fileDesc("ChlhcGlfcHJvdG8vdjEvY29tbW9uLnByb3RvEgxhcGlfcHJvdG8udjEiDwoNRW1wdHlSZXNwb25zZUIzWjFnaXRodWIuY29tL2gtc2NhcGUvaWVzYXB1cmkvZ28vYXBpX3Byb3RvL3YxO2FwaXYxYgZwcm90bzM");

/**
 * @generated from message api_proto.v1.EmptyResponse
 */
export type EmptyResponse = Message<"api_proto.v1.EmptyResponse"> & {
};

/**
 * Describes the message api_proto.v1.EmptyResponse.
 * Use `create(EmptyResponseSchema)` to create a new message.
 */
export const EmptyResponseSchema: GenMessage<EmptyResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_common, 0);

